<template>
  <div>
    <BreadCrumbs
      :children="[
        {
          text: `Bonos`,
        },
      ]"
    />

    <div class="card ml-15">
      <div class="card-body">
        <div class="col-sm-7 mb-2">
          <input
            type="text"
            @input="filterByIdNumberCell"
            v-model="filter"
            class="form-control"
            placeholder="Filtrar por cédula, cédula"
          />
        </div>
        <ul class="nav nav-tabs mb-3" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation">
            <a
              @click="getGiftCardsWithOutUse()"
              class="nav-link active"
              id="pills-home-tab"
              data-toggle="pill"
              href="#pills-home"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
              >Pendientes</a
            >
          </li>
          <li class="nav-item" role="presentation">
            <a
              @click="getGiftCardsWithUse()"
              class="nav-link"
              id="pills-profile-tab"
              data-toggle="pill"
              href="#pills-profile"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              >Redimidos</a
            >
          </li>
        </ul>

        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <!-- ORDEN COMERCIOS -->

            <div v-if="loading" class="text-center">
              <Loader />
            </div>
            <div v-else class="table-wraper">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th>Código</th>
                    <th>Comercio</th>
                    <th>Comprador</th>
                    <th>Cantidad (USD)</th>
                    <th>Cantidad (DOP)</th>
                    <th>Recibe - Nombre</th>
                    <th>Recibe - Cédula</th>
                    <th>Recibe - Teléfono</th>
                    <th>Nota</th>
                    <th>Estado</th>
                    <th>Fecha de compra</th>
                    <th class="text-center">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="x in giftcards" :key="x.id">
                    <td>{{ x.Code }}</td>
                    <td>
                      {{ x.CompanyByWeb != null ? x.CompanyByWeb.Name : "" }}
                    </td>
                    <td>{{ x.User ? x.User.Name : "" }}</td>
                    <td>{{ x.Amount }}</td>
                    <td>{{ x.AmountDOP }}</td>
                    <td>{{ x.ReceiverName }}</td>
                    <td>{{ x.ReceiverReference }}</td>
                    <td>{{ x.ReceiverPhone }}</td>
                    <td>{{ x.Note }}</td>
                    <td>{{ x.Status }}</td>
                    <td>{{ x.createdAt | formaDate }}</td>
                    <td class="text-center">
                      <a
                        v-if="!x.UsedAt"
                        href="#"
                        @click.prevent="markAsUsed(x)"
                        class="text-primary cursor"
                        title="Marcar como usado"
                        ><i class="fa fa-check"></i
                      ></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- DISTANCIA RANGO -->
          <div
            class="tab-pane fade show"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <!-- DISTANCIA RANGO -->
            <div v-if="loading" class="text-center">
              <Loader />
            </div>
            <div v-else class="table-wraper">
              <table class="table">
                <thead class="thead-light">
                  <tr>
                    <th>Código</th>
                    <th>Comercio</th>
                    <th>Comprador</th>
                    <th>Cantidad (USD)</th>
                    <th>Cantidad (DOP)</th>
                    <th>Recibe - Nombre</th>
                    <th>Recibe - Cédula</th>
                    <th>Recibe - Teléfono</th>

                    <th>Estado</th>
                    <th>Fecha de uso</th>
                    <th>Realizado por</th>
                    <th>Tienda</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="x in giftcards" :key="x.id">
                    <td>{{ x.Code }}</td>
                    <td>
                      {{ x.CompanyByWeb != null ? x.CompanyByWeb.Name : "" }}
                    </td>
                    <td>{{ x.User ? x.User.Name : "" }}</td>
                    <td>{{ x.Amount }}</td>
                    <td>{{ x.AmountDOP }}</td>
                    <td>{{ x.ReceiverName }}</td>
                    <td>{{ x.ReceiverReference }}</td>
                    <td>{{ x.ReceiverPhone }}</td>

                    <td>{{ x.Status }}</td>
                    <td>{{ x.UsedAt }}</td>
                    <td>{{ x.MadeBy }}</td>
                    <td>{{ x.Store }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from "../components/Breadcrumbs";
import Loader from "../components/Loader";
import { UtilsService } from "../../services/UtilsService";
import { UserService } from "../../services/UserService";
import Swal from "sweetalert2";
import moment from "moment";
export default {
  name: "GiftCards",
  components: {
    BreadCrumbs,
    Loader,
  },
  filters: {
    formaDate(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      }
    },
    formaDateCreate(value) {
      if (value) {
        return moment.utc(value).format("hh:mm:ss A");
      }
    },
  },
  data() {
    return {
      utilsService: new UtilsService(),
      userService: new UserService(),
      loading: false,
      giftcards: [],
      giftCardsAll: [],
      isUsed: false,
      filter: "",
      show: true,
      giftcardsFilter: [],
      users: [],
    };
  },
  methods: {
    async markAsUsed(giftCard) {
      var made = "";
      var store = "";
      await Swal.fire({
        title: "Campos a llenar",
        showCancelButton: true,
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        html:
          '<input id="swal-input1" placeholder="Realizado por" class="swal2-input">' +
          '<input id="swal-input2" placeholder="Nombre de la tienda" class="swal2-input">',
        preConfirm: function () {
          return new Promise(async function (resolve) {
            resolve([$("#swal-input1").val(), $("#swal-input2").val()]);
          });
        },
        onOpen: function () {
          $("#swal-input1").focus();
        },
      }).then(async function (result) {
        if (result.dismiss == "cancel" || result.dismiss == "backdrop") {
        } else {
          // this.inserData(result.value[0], result.value[1]);
          made = result.value[0];
          store = result.value[1];
        }
      });
      if (made == "" && store == "") {
        Swal.showValidationMessage(`No puedes dejar ningun campo vacio.`);
        return;
      } else {
        this.inserData(giftCard, made, store);
      }
    },
    async inserData(giftCard, made, store) {
      if (made == "" && store == "") {
        Swal.showValidationMessage(`No puedes dejar ningun campo vacio.`);
        return;
      } else {
        const ok = await this.$helpers.confirm("Esto no se puede deshacer");
        if (!ok) {
          return;
        }

        await this.utilsService.markGiftCardAsUsed(giftCard.Id, made, store);
        this.get();
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Se ha guardado correctamente.",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    getGiftCardsWithOutUse() {
      this.loading = true;
      this.isUsed = false;
      this.getWithOutUse();
      this.filterByIdNumberCell();
      this.loading = false;
    },
    getGiftCardsWithUse() {
      this.loading = true;
      this.isUsed = true;
      this.getWithUse();
      this.filterByIdNumberCell();
      this.loading = false;
    },
    getWithOutUse() {
      this.giftcards = this.giftCardsAll.filter((g) => g.Status == "Sin usar");
      this.giftcardsFilter = this.giftcards;
    },
    getWithUse() {
      this.giftcards = this.giftCardsAll.filter((g) => g.Status == "Usado");
      this.giftcardsFilter = this.giftcards;
    },
    filterByIdNumberCell(event) {
      if (this.filter == "") {
        if (this.isUsed) {
          this.getWithUse();
        } else {
          this.getWithOutUse();
        }
      } else {
        if (this.isUsed) {
          this.giftcards = this.giftcardsFilter.filter(
            (g) =>
              g.ReceiverReference.toString().includes(
                this.filter.toLowerCase()
              ) ||
              g.ReceiverPhone.toString().includes(this.filter.toLowerCase())
          );
        } else {
          this.giftcards = this.giftcardsFilter.filter(
            (g) =>
              g.ReceiverReference.toString().includes(
                this.filter.toLowerCase()
              ) ||
              g.ReceiverPhone.toString().includes(this.filter.toLowerCase())
          );
        }
      }
    },
    async get() {
      this.loading = true;
      try {
        const company = this.$store.getters.isAdmin
          ? null
          : this.$store.getters.getCompany;

        const res = await this.utilsService.getGiftCards(company);
        if (res.ok) {
          this.giftCardsAll = res.data;

          console.log(this.giftCardsAll);
          this.filterByIdNumberCell();
        } else {
          this.$helpers.message("Error", res.message, "error");
        }
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");
      }
      this.loading = false;
    },
  },

  beforeMount() {
    this.get();
  },
};
</script>

<style scoped>
tbody td {
  font-weight: 500 !important;
}
.fa {
  font-size: 1.2rem;
}
</style>
